export class RequestChangePassword {
  oldPassword: string;
  newPassword1: string;
  newPassword2: string;
  logUser: string ;
}
